module.exports = __webpack_public_path__ + "static/media/details-2.56591159.png";